import { RolModulePermissionEnum } from '@core/enums';
import { RolModuloPermiso, RolModuloPermisoForm, RolModuloPermisoUpsert } from '@models/.';

export function transformToData(rolModulePermission: RolModuloPermiso | null): RolModuloPermiso | null {
  if (!rolModulePermission) return null;
  
  return {
    ...rolModulePermission,
  };
}

export function transformToForm(rolModulePermission?: RolModuloPermiso): RolModuloPermisoForm | undefined {
  if (!rolModulePermission) return;
  
  const {
    idPermission: id,
    moduleId: moduleId,
    name: name,
    code: code,
    enabled: enabled,
  } = rolModulePermission;
  
  return {
    id,
    moduleId,
    name,
    code,
    enabled,
  };
}

export function transformArrayToForm(rolModulePermissions: RolModuloPermiso[] | null | undefined): RolModuloPermisoForm[] {
  return (rolModulePermissions ?? []).map((rolModulePermission) => (transformToForm(rolModulePermission)) as RolModuloPermisoForm) ?? [];
}

export function transformArrayFormToOrder(rolModulePermissionsForm: RolModuloPermisoForm[]): RolModuloPermisoForm[] {
  const customOrder = [
    RolModulePermissionEnum.CreateRole,
    RolModulePermissionEnum.EditRole,
    RolModulePermissionEnum.DeleteRole,
    RolModulePermissionEnum.CreateUser,
    RolModulePermissionEnum.EditUser,
    RolModulePermissionEnum.ActivateUser,
    RolModulePermissionEnum.DeactivateUser,
    RolModulePermissionEnum.CreateStore,
    RolModulePermissionEnum.EditStore,
    RolModulePermissionEnum.ActivateStore,
    RolModulePermissionEnum.DeactivateStore,
    RolModulePermissionEnum.AddLicenses,
    RolModulePermissionEnum.DeleteLicenses,
    RolModulePermissionEnum.CreateAccount,
    RolModulePermissionEnum.EditAccount,
    RolModulePermissionEnum.ActivateAccount,
    RolModulePermissionEnum.DeactivateAccount,
  ];
  
  return (rolModulePermissionsForm ?? []).sort((a, b) => {
    const indexA = customOrder.indexOf(a.code as RolModulePermissionEnum);
    const indexB = customOrder.indexOf(b.code as RolModulePermissionEnum);
      
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    
    return 0;
  });
}

export function transformToUpsert(rolModulePermissionForm: RolModuloPermisoForm): RolModuloPermisoUpsert | undefined {
  if (!rolModulePermissionForm) return;
  
  const {
    id: idPermission,
    enabled,
  } = rolModulePermissionForm
  
  return {
    idPermission,
    enabled: !!enabled,
  };
}

export function transformArrayToUpsert(rolModulePermissionsForm: RolModuloPermisoForm[] | null | undefined): RolModuloPermisoUpsert[] {
  return (rolModulePermissionsForm ?? []).map((rolModulePermissionForm) => (transformToUpsert(rolModulePermissionForm)) as RolModuloPermisoUpsert) ?? [];
}